<template>
  <vs-popup
    class="darkened"
    title="Insert from template"
    :active.sync="addFromTemplatePopup"
  >
    <vs-row class="mb-5" vs-justify="center">
      <vs-col
        v-for="(template, index) in templates"
        :key="index"
        type="flex"
        style=""
        vs-justify="center"
        vs-align="center"
        vs-w="4"
        class="template-item"
      >
        <vs-card>
          <div slot="header">
            <h3>{{ template.name }}</h3>
          </div>
          <div>
            <span>{{ template.description }}</span>
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button
                color="primary"
                @click.native="confirmImport(template.templateId)"
                icon="content_copy"
              ></vs-button>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
      <!--<vs-col
        type="flex"
        vs-justify="center"
        class="ml-4"
        vs-align="center"
        vs-w="5"
      >
        <vs-card>
          <div slot="header">
            <h3>Primary template 2</h3>
          </div>
          <div>
            <span
              >Primary template meant for DK venues. Uses lorem ipsum text right
              here</span
            >
          </div>
          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <vs-button color="primary" icon="play_arrow"></vs-button>
            </vs-row>
          </div>
        </vs-card>
      </vs-col>-->
    </vs-row>
    <p>
      Click a template to add all of its campaigns, comments, events and social
      media content to this venue.
      <strong>Note: this cannot be undone</strong>
    </p>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeYear: null,
      templateId: null,
      templates: [
        {
          name: "Denmark",
          description: "Activation Plan Template for Denmark (Odense) 2022",
          templateId: "Odense2022AP",
        },
        {
          name: "Norge",
          description: "Activation Plan Template for Norge (Oslo) 2022",
          templateId: "Oslo2022AP",
        },
      ],
      addFromTemplatePopup: false,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
    }),
  },
  methods: {
    show(activeYear) {
      this.activeYear = activeYear;
      this.addFromTemplatePopup = true;
    },
    confirmImport(templateId) {
      this.selectedTemplateId = templateId;
      this.addFromTemplatePopup = false;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: `Import from template into ${this.activeVenue.name} for year ${this.activeYear}?`,
        accept: this.importTemplate,
      });
    },
    async importTemplate() {
      this.$vs.loading();
      const dto = {
        templateId: this.selectedTemplateId,
        venueId: this.activeVenue.venueId,
        year: this.activeYear,
      };
      await this.$store.dispatch(
        "activationPlan/importEventsFromTemplate",
        dto
      );
      await this.$store.dispatch(
        "activationPlan/importCampaignsFromTemplate",
        dto
      );
      await this.$store.dispatch(
        "activationPlan/importCommentsFromTemplate",
        dto
      );
      this.$vs.loading.close();
    },
  },
};
</script>


<style>
.darkened > .vs-popup {
  background-color: #f8f8f8 !important;
}

.template-item:not(:first-child) {
  margin-left: 20px !important;
}
</style>
